import { fromFetch } from 'rxjs/fetch';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { authwsEnvironment } from './authws-environment';
import { jwtSchema } from './schemas/jwt.schema';

export function postJwt(
  token: { authenticationToken: string } | { refreshToken: string }
) {
  return fromFetch(
    new Request(authwsEnvironment.tokenUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
      },
      body: JSON.stringify(token),
    })
  ).pipe(selectData(jwtSchema));
}
